/* import __COLOCATED_TEMPLATE__ from './simple-qualification.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();